export const CONTACT_MODULE = 'contact'


// WEBPACK FOOTER //
// ./src/store/contact/contact-types.store.ts